'use es6';

import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import memoize from 'transmute/memoize';
import { jsx as _jsx } from "react/jsx-runtime";
export default memoize(() => /*#__PURE__*/_jsx(Ribbon, {
  use: "free",
  paddingInlineEnd: "100",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "testSurvey"
  })
}));